import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { brand } from './config/brand';
import { App } from './app/App';

document.title = brand.name;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
